import { ActionMessageBuilder } from '@gogame/query';

export const messagesInfluencerChannels = new ActionMessageBuilder(
  'Influencer Channels'
);

export const messagesCategories = new ActionMessageBuilder('Categories');
